export type Nullable<T> = T | null
export type Locale = 'en' | 'ar'

export enum TravelDirection {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
  UNKNOWN = 'UNKNOWN',
}

export enum ProductCode {
  INBOUND = 'travelinbound',
  OUTBOUND = 'traveloutbound',
}

export enum CONTACTS_KEYS {
  EMAIL = 'email_qatar_visitors',
  WA_LINK_GENERAL = 'walink_qatar_general',
  WA_LINK_MANDATORY = 'walink_qatar_visitors',
  PHONE_LINK = 'phonelink_qatar_general',
  PHONE_LINK_TEXT = 'phone_qatar_general',
  QD_APP_DOWNLOAD_LINK = 'qdlink_qatar_visitors',
}
